var map = {
	"./vs01.jpg": 6166,
	"./vs02.jpg": 3921,
	"./vs03.jpg": 9588,
	"./vs04.jpg": 1023,
	"./vs05.jpg": 9314,
	"./vs06.jpg": 5245,
	"./vs07.jpg": 3024,
	"./vs08.jpg": 4635,
	"./vs09.jpg": 6590
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 379;